<template>
  <div>
    <md-card>
      <md-card-content class="md-layout">
        <div class="md-layout-item md-layout md-size-100 pl-0">
          <p class="md-layout-item md-size-100 pb-4 p-0">
            {{ $t("extended_exportation.gpa_rank_title") }}
          </p>
          <div class="md-layout-item md-size-30 pl-0">
            <md-field>
              <label :for="programSelect.name">{{ programSelect.label }}</label>
              <md-select
                :name="programSelect.name"
                :id="programSelect.name"
                v-model="programSelect.value"
              >
                <md-option
                  v-for="option in programSelect.options"
                  :value="option.id"
                  :key="option.id + option.name"
                  >{{ option.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-30">
            <checkbox-multi-select
              :label="gradesSelect.label"
              :options="gradesSelect.options"
              :trackBy="gradesSelect.trackBy"
              :displayField="gradesSelect.displayField"
              v-model="gradesSelect.value"
              :showSelectAll="true"
            ></checkbox-multi-select>
          </div>
          <div class="md-layout-item md-size-30">
            <date-picker-custom
              :label="$t('extended_exportation.enter_date')"
              v-model="inputDate"
            ></date-picker-custom>
          </div>
        </div>
        <div class="md-layout-item md-layout md-size-100 pl-0">
          <p class="md-layout-item md-size-100 pl-0">
            {{ $t("extended_exportation.gpa_rank_sort") }}
          </p>
          <div class="md-layout-item md-size-33 md-small-size-100 pl-0">
            <md-radio v-model="gpaSelected" :value="gpaValue.weightGPA">
              <span class="text-gray-800">{{
                $t("extended_exportation.weight_gpa")
              }}</span>
            </md-radio>
          </div>
          <div class="md-layout-item md-size-35 md-small-size-100">
            <md-radio v-model="gpaSelected" :value="gpaValue.bonusGPA"
              ><span class="text-gray-800">{{
                $t("extended_exportation.weight_gpa_bonus")
              }}</span></md-radio
            >
          </div>
        </div>
      </md-card-content>
    </md-card>
    <div class="flex justify-center pt-2">
      <md-button class="md-warning md-round" @click="exportPDF()"
        >{{ $t("communication.send_email") }}
      </md-button>
    </div>
  </div>
</template>

<script>
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import { service_paths } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";

export default {
  components: { CheckboxMultiSelect },
  data() {
    return {
      programSelect: {
        label: this.$t("program.program_gpa"),
        name: "program__",
        value: "",
        type: "select",
        options: []
      },
      gradesSelect: {
        label: this.$t("common.grade"),
        value: [],
        type: "checkbox-multi-select",
        options: [],
        trackBy: "name",
        displayField: "name",
        showSelectAll: true
      },
      inputDate: "",
      gpaSelected: "",
      gpaValue: {
        weightGPA: "Weighted GPA",
        bonusGPA: "Weighted GPA w bonus point"
      }
    };
  },
  created() {
    this.fetchProgramOpts();
    this.fetchGradeOpts();
    this.gpaSelected = this.gpaValue.weightGPA;
  },
  methods: {
    async fetchProgramOpts() {
      await this.$axios.get(`${service_paths.programs}`).then(response => {
        this.programSelect.options = response.data.data
          .map(program => ({
            id: getId(program),
            name: program.name
          }))
          .sort((currentProgram, newProgram) => {
            return currentProgram.name.localeCompare(newProgram.name);
          });
        this.programSelect.value = this.programSelect.options[0].id;
      });
    },
    async fetchGradeOpts() {
      await this.$axios
        .get(`${service_paths.grades}`, { limit: 20 })
        .then(response => {
          this.gradesSelect.options = response.data.data.map(grade => {
            this.gradesSelect.value.push(grade.name);
            return {
              id: getId(grade.id),
              name: grade.name
            };
          });
        });
    },
    exportPDF() {
      let params = {
        entered: this.inputDate,
        object: this.gpaSelected,
        program_id: this.programSelect.value,
        grade_names: this.gradesSelect.value
      };
      this.$axios
        .get(`${service_paths.export}/gpa/pdf`, params)
        .then(response => {
          if (response.status === 200) {
            Message.success(
              this.$t("extended_exportation.export_file_successfully")
            );
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .checkbox-multi-selections label {
  display: block;
  margin: -3px 0;
  color: #aaa;
  font-weight: 400;
}
</style>
